// Styles
import '@mdi/font/css/materialdesignicons.css'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'
import '@/styles/main.scss'
import 'vuetify/styles'
import '@/overrides.scss'

// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify({
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            mdi,
        },
    },
}
)
